const { _n } = wp.i18n;

export default class StarRating {
  constructor(el, options = {}) {
    this.el = el;
    let starEls = this.el ? [].slice.call(this.el.querySelectorAll('.checkbox-star')) : null;
    this.stars = starEls ? starEls.map( el => {
      const input = el.querySelector('.checkbox-star__input');
        return {
          parent: el,
          input,
          active: input.checked,
        }
      }) : [];
    this.options = options;
    this.indicators = [];

    this.init();
  }

  init()
  {
    this.setActiveStar();
    this.stars.forEach( star => {
      star.input.addEventListener('change', this.onRatingSelect.bind(this));
      star.parent.addEventListener('mouseenter', this.onRatingHover.bind(this));
      star.parent.addEventListener('mouseleave', this.onRatingHover.bind(this));
    });

    if(true === this.options.indicator){
      this.initIndicator();
    }
  }

  initIndicator()
  {
    if(this.options.indicatorEl) {
     for(let i = 1; i <= 5; i++) {
       let el = document.createElement('span');
       el.classList.add(`star-indicator-${i}`);
       el.textContent = `${_n(`%s star and up`, `%s stars and up`, i, 'canopia').replace('%s', i)} (${this.stars[i - 1].parent.dataset.count})`;
       this.indicators.push(el);
       this.options.indicatorEl.appendChild(el);
     }
    }
  }

  setActiveStar( activeStarIndex = -1 ) {
    this.stars.map( (star, idx ) => {
      if( star.input.checked ) {
        star.active = true;
        if( ! star.parent.classList.contains('active') ) {
          star.parent.classList.add('active');
        }
        this.dispatchEvent(StarRating.getValueByIndex(idx));
      } else {
        star.active = false;
        if(activeStarIndex > idx) {
          if( ! star.parent.classList.contains('active') ) {
            star.parent.classList.add('active');
          }
        } else {
          star.parent.classList.remove('active');
        }
      }
      return star;
    } );

    if( activeStarIndex === -1 ) {
      activeStarIndex = this.stars.findIndex( el => {
        return el.active;
      });

      if( activeStarIndex > -1 ) {
        for ( let i = activeStarIndex; i > -1; i--) {
          if(!this.stars[i].parent.classList.contains('active')) {
            this.stars[i].parent.classList.add('active');
          }
        }
      }
    }
  }

  clear(skipEvent = false) {
    this.stars.forEach( star => {
      star.parent.classList.remove('active');
      star.input.checked = false;
      star.active = false;
    } );

    if( ! skipEvent ) {
      this.dispatchEvent(0);
    }
  }

  dispatchEvent(rating, eventName = 'set.star.rating') {
    const Ev = new CustomEvent(eventName, {
      bubbles: false,
      detail: {
        rating,
      },
    });

    this.el.dispatchEvent(Ev);
  }

  onRatingSelect(event)
  {
    this.setActiveStar( StarRating.getIndexByValue( event.target.value ) );
  }

  onRatingHover(event)
  {
    const action = event.type === 'mouseenter' ? 'add' : 'remove';
    let el = event.target;

    if(!el || ! el.classList || typeof el.classList[action] !== 'function') {
      return;
    }

    let prev = el.previousElementSibling;
    let rating = el.dataset.rating;

    el.classList[action]('hover');

    this.indicators.forEach((item, index) => {
      if('mouseleave' === event.type) {
        item.classList.remove('d-inline-block');
      } else {
        if(rating && index === parseInt(rating) - 1 ) {
          item.classList.add('d-inline-block');
        } else {
          item.classList.remove('d-inline-block');
        }
      }

    })

    while(prev) {
      prev.classList[action]('hover');
      prev = prev.previousElementSibling;
    }
  }

  getValue()
  {
    return StarRating.getValueByIndex(this.stars.findIndex(star => star.active));
  }

  setValue(value, skipEvent = false)
  {
    if(0 === value) {
      this.clear();
    } else {
      this.stars.map( (star, idx ) => {
        star.active = value === idx;
        star.input.checked = value === idx;
        if(star.active) {
          star.parent.classList.add('active');
        } else {
          star.parent.classList.remove('active');
        }
      });
    }
    if(!skipEvent) {
      this.dispatchEvent(value);
    }
  }

  static getValueByIndex( index ) {
    return index + 1;
  }

  static getIndexByValue( value ) {
    return value - 1;
  }
}
